import Store from 'Store/.';
import { Dispatch } from 'redux';
import Api from 'Helpers/Api';

import { 
  InfoFaqAction, 
  setIsFetching, 
  setFetchFailed, 
  setFaqList,
} from 'Components/InfoFaq/Redux/actions';

export const fetchFaqList = () => {
  return async (dispatch: Dispatch<InfoFaqAction>): Promise<void> => {
    const { isFetching, faqList } = Store.getState().infoFaq;

    if (isFetching || faqList.length > 0) {
      return null;
    }

    dispatch(setIsFetching());

    try {
      const response = await Api.get('FAQ');

      if (response.status !== 200) {
        dispatch(setFetchFailed());
      } else {
        const newFaqList: Julius.Website.FAQViewModel[] = await response.json();
        dispatch(setFaqList(newFaqList));
      }
    } catch (e) {
      dispatch(setFetchFailed());
    }
  };
};


// WEBPACK FOOTER //
// ./src/components/InfoFaq/Redux/thunks.tsx